export const AUTH_TOKEN = "authToken";
export const USER = "user";
